import { render, staticRenderFns } from "./product_item.vue?vue&type=template&id=6fa8f00c"
import script from "./product_item.vue?vue&type=script&lang=js"
export * from "./product_item.vue?vue&type=script&lang=js"
import style0 from "./product_item.vue?vue&type=style&index=0&id=6fa8f00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports